import React from 'react';

const WalksTable = () => {
  const walks = [
    { id: 1, time: '08:00 AM', pet: 'Max', walker: 'Carlos', route: 'Parque Central', status: 'Completado' },
    { id: 2, time: '10:30 AM', pet: 'Bella', walker: 'María', route: 'Sendero Ecológico', status: 'En progreso' },
    { id: 3, time: '12:00 PM', pet: 'Rocky', walker: 'Juan', route: 'Zona Residencial', status: 'Agendado' },
    { id: 4, time: '03:00 PM', pet: 'Luna', walker: 'Ana', route: 'Parque de los Perros', status: 'Agendado' },
    { id: 5, time: '05:30 PM', pet: 'Toby', walker: 'Carlos', route: 'Alrededores', status: 'Pendiente' }
  ];

  const statusColors = {
    'Completado': 'bg-green-100 text-green-800',
    'En progreso': 'bg-blue-100 text-blue-800',
    'Agendado': 'bg-yellow-100 text-yellow-800',
    'Pendiente': 'bg-gray-100 text-gray-800'
  };

  return (
    <div className="ml-64 p-6">
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hora</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mascota</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Paseador</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ruta</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {walks.map((walk) => (
              <tr key={walk.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{walk.time}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{walk.pet}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{walk.walker}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{walk.route}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${statusColors[walk.status]}`}>
                    {walk.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WalksTable;